module.exports = __webpack_public_path__ + "img/dp_lp_pc_experience_bg.aa2d48e9.jpg";